export class NumberUtils {
    static toNumberOrUndefined(convert: string | null | undefined): number | undefined {
        if (convert == null) {
            return undefined
        }
        const asNum = Number(convert)
        if (Number.isNaN(asNum)) {
            return undefined
        }
        return asNum
    }
}
